import React from 'react';

interface Props {
  children: React.ReactNode;
}

export function DialogBody({
  children,
}: Props) {
  return (
    <div className="dialog-body">
      {children}
    </div>
  );
}